import { render, staticRenderFns } from "./admin-managefeature.vue?vue&type=template&id=80f5b476&"
import script from "./admin-managefeature.vue?vue&type=script&lang=js&"
export * from "./admin-managefeature.vue?vue&type=script&lang=js&"
import style0 from "./admin-managefeature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports